import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/aiia/src/app/[locale]/@drawer/Drawer.tsx");
